const kpi = [
  {
    text: 'Conversion rate',
    value: '+15%',
  },
  {
    text: 'Average Order Value',
    value: '+15% to 45%',
  },
  {
    text: 'Returns Decrease',
    value: '-55%',
  },
  {
    text: 'Cart Abandonment',
    value: '-10% to -15%',
  },
];

export default kpi;
